<template>
    <img
        :src="closeImg"
        @click="closeDialog"
    />
</template>

<script setup>
import closeImg from "@/assets/dialog/close.svg"
import { useStore } from "vuex"

const store = useStore()

const closeDialog = () => {
    const nextDialog = store.getters.getNextDialog

    if (!!nextDialog) {
        store.commit("setDialog", nextDialog)
        store.commit('setNextDialog')
    } else {
        store.commit("closeDialog")
    }
}


</script>

<style lang="scss" scoped>
img {
    position: relative;
    padding: 10px;
    margin: 7px 7px -40px auto;
    box-sizing: border-box;
    border-radius: 3px;
    background-color: var(--block-color);
    cursor: pointer;
    z-index: 12;
}
</style>
